import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: ':lang?',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
    },
    {
      path: '/themen/:thema/:lang?',
      name: 'thema',
      component: () => import(/* webpackChunkName: "thema" */ './views/Thema.vue')
    },
    {
      path: '/themenseite/:lang?',
      name: 'themen',
      component: () => import(/* webpackChunkName: "themen" */ './views/Themen.vue')
    },
    {
      path: '/dossiers/:dossier/:lang?',
      name: 'dossier',
      component: () => import(/* webpackChunkName: "dossier" */ './views/Dossier.vue')
    },
    {
      path: '/publikationen/:publication/:lang?',
      name: 'publikation',
      component: () => import(/* webpackChunkName: "publikation" */ './views/Publikation.vue')
    },
    {
      path: '/ethnien/:lang?',
      name: 'ethnien',
      component: () => import(/* webpackChunkName: "ethnien" */ './views/Ethnien.vue')
    },
    {
      path: '/ethnie/:ethnie/:lang?',
      name: 'ethnie',
      component: () => import(/* webpackChunkName: "ethnie" */ './views/Ethnie.vue')
    },
    {
      path: '/digitale-bibliothek-gesamt/:lang?',
      name: 'dl',
      component: () => import(/* webpackChunkName: "dl" */ './views/DigitalLibrary.vue')
    },
    {
      path: '/verlag/:lang?',
      name: 'verlag',
      component: () => import(/* webpackChunkName: "dl" */ './views/DigitalLibrary.vue')
    },
    {
      path: '/verlag/:section/:lang?',
      name: 'verlagSection',
      component: () => import(/* webpackChunkName: "dl" */ './views/DLSection.vue')
    },
    {
      path: '/digitale-bibliothek/:section/:lang?',
      name: 'dlsection',
      component: () => import(/* webpackChunkName: "dl-section" */ './views/DLSection.vue')
    },
    {
      path: '/sammlungen/:lang?',
      name: 'sammlungen',
      component: () => import(/* webpackChunkName: "sammlungen
      " */ './views/Collections.vue')
    },
    {
      path: '/medien/videos/:lang?',
      name: 'videos',
      component: () => import(/* webpackChunkName: "videos" */ './views/Videos.vue')
    },
    {
      path: '/medien/videos/:video/:lang?',
      name: 'video',
      component: () => import(/* webpackChunkName: "Video" */ './views/Video.vue')
    },
    {
      path: '/medien/ethnographica/:lang?',
      name: 'ethnografica',
      component: () => import(/* webpackChunkName: "ethnographica" */ './views/Ethnographica.vue')
    },
    {
      path: '/medien/fotos/:lang?',
      name: 'fotos',
      component: () => import(/* webpackChunkName: "fotos" */ './views/Fotos.vue')
    },
    {
      path: '/medien/fotos/:id/:lang?',
      name: 'foto',
      component: () => import(/* webpackChunkName: "foto" */ './views/Foto.vue')
    },
    {
      path: '/medien/dossiers/:lang?',
      name: 'dossiers',
      component: () => import(/* webpackChunkName: "dossiers" */ './views/Dossiers.vue')
    },
    {
      path: '/bibliothek/buecher/:lang?',
      name: 'buecher',
      component: () => import(/* webpackChunkName: "buecher" */ './views/Buecher.vue')
    },
    {
      path: '/bibliothek/buecher/:slug/:lang?',
      name: 'buch',
      component: () => import(/* webpackChunkName: "buch" */ './views/Buch.vue')
    },
    {
      path: '/bibliothek/autographen/:lang?',
      name: 'autographen',
      component: () => import(/* webpackChunkName: "autographen" */ './views/Autographen.vue')
    },
    {
      path: '/bibliothek/autographen/:slug/:lang?',
      name: 'autograph',
      component: () => import(/* webpackChunkName: "autograph" */ './views/Autograph.vue')
    },
    {
      path: '/bibliothek/digitales/:lang?',
      name: 'digitales',
      component: () => import(/* webpackChunkName: "digBibs" */ './views/DigitaleBibliothekObjekte.vue')
    },
    {
      path: '/bibliothek/diverse-digitalisate/:lang?',
      name: 'digitalisate',
      component: () => import(/* webpackChunkName: "digitalisate" */ './views/WeitereDigitalisate.vue')
    },
    // {
    //   path: '/sammlung/:objekt/:lang?',
    //   name: 'objekt',
    //   component: () => import(/* webpackChunkName: "objekt" */ './views/Objekt.vue')
    // },
    {
      path: '/tech/audios',
      name: 'tech_audios',
      component: () => import(/* webpackChunkName: "page" */ './views/TechAudios.vue')
    },
    {
      path: '/:page/:lang',
      name: 'page',
      component: () => import(/* webpackChunkName: "page" */ './views/Page.vue')
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
    }
    // Catch all
    // {
    //   path: '/:lang?/*',
    //   redirect: '/'
    // }
  ],
  // scrollBehavior (to, from, savedPosition) {
  //   return { x: 0, y: 0 }
  // }
  scrollBehavior (to, from, savedPosition) {
    // https://router.vuejs.org/guide/advanced/scroll-behavior.html
    if (to.hash) {
      return { selector: to.hash }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  const storeImp = require('./store')
  let store = storeImp.default
  let langs = store.state.langs
  let langParam = to.params.lang
  let invalidLang = langs.indexOf(langParam) === -1
  if (langParam === undefined || invalidLang) {
    langParam = store.state.lang
  }
  store.dispatch('switchLanguage', langParam)
  // let l = router.resolve({ name: to.name })
  if (to.path !== '/' + store.state.lang &&
    to.path !== '/' &&
    typeof to.name === 'undefined' &&
    (to.fullPath !== '/localization/' + store.state.lang ||
    to.fullPath !== '/techchecks/' + store.state.lang)) {
    next({ path: ':lang?', name: 'home' })
  } else {
    next()
  }
})

export default router
